// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"error_wrapper__9Kyh9","content":"error_content__GVW_Z","title":"error_title__NNka2","text":"error_text__5iZF6"};